// extracted by mini-css-extract-plugin
export default {"variables":"VariablesButtonSetPlugin-module__variables__X-k+q","text":"VariablesButtonSetPlugin-module__text__L7PyS","button":"VariablesButtonSetPlugin-module__button__MlAEE"};